import { render } from "./ExportsDropdown.vue?vue&type=template&id=4c09c907&scoped=true&ts=true"
import script from "./ExportsDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExportsDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./ExportsDropdown.vue?vue&type=style&index=0&id=4c09c907&scoped=true&lang=css"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c09c907"],['__file',"resources/js/components/app/header/ExportsDropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c09c907"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c09c907', __exports__)) {
    console.log('reload')
    api.reload('4c09c907', __exports__)
  }
  
  module.hot.accept("./ExportsDropdown.vue?vue&type=template&id=4c09c907&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('4c09c907', render)
  })

}


export default __exports__